import { render, staticRenderFns } from "./DashboardPages.vue?vue&type=template&id=3a4c5b84&scoped=true&lang=pug"
import script from "./DashboardPages.vue?vue&type=script&lang=js"
export * from "./DashboardPages.vue?vue&type=script&lang=js"
import style0 from "./DashboardPages.vue?vue&type=style&index=0&id=3a4c5b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c5b84",
  null
  
)

export default component.exports